import React from "react";
import {
  compose,
  withHandlers,
  branch,
  renderNothing,
  renderComponent
} from "recompose";
import Linkify from "react-linkify";
import { withUserInfo } from "app/auth/hocs";
import { withAuth } from "app/auth/hocs";
import styled from "styled-components";
import { withCommentList } from "./hocs";
import { Colors, ProgressBar } from "@blueprintjs/core";
import CommentByline from "./CommentByline";
import { LIST_COMMENTS } from "./constants";
import { FormattedMessage } from "react-intl";

const enhanceCommentList = compose(
  withCommentList,
  branch(props => !props.commentList, renderNothing),
  branch(
    props =>
      !props.commentList.result && props.commentList[LIST_COMMENTS.PENDING],
    renderComponent(ProgressBar)
  ),
  withHandlers({
    deleteFromList: props => commentSlug => {
      const { resourceId, resourceType } = props;
      props.deleteComment({ resourceId, resourceType, commentSlug });
    }
  }),
  withAuth
);

const StyledList = styled.ul`
  margin: 0;
  padding: 0;
  list-style: none;
  & li {
    margin: 0;
    margin-bottom: 1em;
    padding: 1ex 2ex;
    border: 1px solid ${Colors.GRAY5};
    border-radius: 0.25em;
  }
  & li.city-official {
    background-color: rgba(255, 0, 0, 0.1);
  }
  & li.city-official .icon span {
    color: rgb(128, 0, 0);
  }
`;

const enhance = compose(withUserInfo);

const Comment = enhance(props => {
  const { auth, posted, body, slug, userId, deleteFromList, user } = props;

  const isCityOfficial =
    user &&
    user.orgRoles &&
    (user.orgRoles[Object.keys(user.orgRoles)[0]] === "topic-moderator" ||
      user.orgRoles[Object.keys(user.orgRoles)[0]] === "city-official");
  const className = isCityOfficial ? "city-official" : "";
  return (
    <li className={className}>
      <CommentByline
        userId={userId}
        creationDate={posted.$date}
        isCityOfficial={isCityOfficial}
        deleteLink={
          userId === auth.userId && (
            <a onClick={() => deleteFromList(slug)}>
              [<FormattedMessage id="text.delete" defaultMessage="Delete" />]
            </a>
          )
        }
      />
      <Linkify>{body || "(empty)"}</Linkify>
    </li>
  );
});

const CommentList = enhanceCommentList(props => {
  const {
    commentList: { result },
    deleteFromList,
    auth
  } = props;
  return (
    <StyledList>
      {(result || []).map((comment, index) => {
        return (
          <Comment
            key={comment.slug}
            auth={auth}
            userId={comment.author}
            {...comment}
            deleteFromList={deleteFromList}
          />
        );
      })}
    </StyledList>
  );
});

export default CommentList;



// WEBPACK FOOTER //
// ./src/app/comments/CommentList.js